import { DECISION_FETCH } from './actions.type';

import { WINDOW_API_ERROR_SHOW } from '../store/mutations.type';

import { Api as ApiDecyzje } from '../api/api-decyzje';

const api = new ApiDecyzje();

const initialState = {
  decision: undefined
};

const state = Object.assign({}, initialState);

const actions = {
  async [DECISION_FETCH](context, decisionId) {
    var response = null;
    try {
      response = await api.getDecyzjeById({
        wso2_id: this.contextEmail,
        orgid: this.contextOrganizationId,
        id: decisionId
      });
    } catch (e) {
      context.commit(WINDOW_API_ERROR_SHOW, e);
    }

    if (response) {
      let decision = response.body.decyzje;
      context.commit('setDecision', decision);
    }
  }
};

const mutations = {
  setDecision(state, decision) {
    state.decision = decision;
  }
};

const getters = {
  decision(state) {
    return state.decision;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
